import DBEvent from './dbEvent.class';

export default class Mention extends DBEvent {
  get type() { return 'mention'; }

  get via() { return 'mention'; }

  get isMention() { return true; }
}
